 

import {routes as recurrent} from './recurrent'
import {routes as transaction} from './transaction'
import {routes as dashboard} from './dashboard'
import {routes as customer} from './customer'
export default [
     
    ...recurrent, 
    ...transaction, 
    ...dashboard, 
    ...customer, 
]